import initialState from '../initialstate';
import {get as _get} from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';
import {GET_CLIENT_REQUEST} from '../../actions/actiontypes';

export default function getClientRequestReducer(state = initialState.clientRequest, action) {
	switch (action.type) {
		case GET_CLIENT_REQUEST: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return data;
			}
			return [];
		}
		default:
			return state;
	}
}
